import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment-timezone';
import { useSelector } from 'react-redux';

import Button from '../../Buttons/Button/Button';
import Tags from '../../Tags/Tags';
import { ReactComponent as Calendar } from '../../../assets/icons/Calendar.svg';
import { ReactComponent as ArrowDownLine } from '../../../assets/icons/ArrowDownLine.svg';
import Context from '../../../store/context';
import apiMethods from '../../../apis';
import useGet from '../../../services/hooks/http/useGet';
import utils from '../../../services/utils';

import classes from './DetailsChargeCard.module.scss';

const DetailsChargeCard = ({
  className,
  onClick,
  onClickDetail,
  client,
  isChecked,
  payed = false,
  deleteHandler,
  isSupplier = false,
  isModal = false,
  refetch,
  subtitle,
  isCarrayOutCharge,
  isChargesMade,
  isPaymentReceived
}) => {

  const { clientName, dueTotal, issueDate, dueDate, payableAmountAfterRetentions, paymentState, id, purchaseId } = client;


  const containerClasses = [
    'card-check',
    payed ? classes['card-process'] : '',
    isModal ? classes['card-modal'] : classes['card-not-modal']
  ];
  if (isChecked) {
    containerClasses.push('border-selected');
  }
  if (className) {
    containerClasses.push(className);
  }

  // // const navigate = useNavigate();

  const goSupplier = () => {
    // const url = `/itemsupplier/${supplierId}`;
    // navigate(url);
  };

  const handleCopy = async () => {
    await navigator.clipboard.writeText('This is the charges link...')
  }

  const [fetchReceipt, setFetchReceipt] = useState(false);
  const [fetchVoucher, setFetchVoucher] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const {
    isSuccess: getReceiptSuccess,
    data: getReceipt,
    isError: getReceiptError,
    errorMessage: receiptErrorMessage
  } = useGet(apiMethods.getChargePaymentReceipt, [purchaseId], fetchReceipt);

  const {
    isSuccess: getVoucherSuccess,
    data: getVoucher,
    isError: getVoucherError,
    errorMessage: voucherErrorMessage
  } = useGet(apiMethods.getChargeVoucher, [purchaseId], fetchVoucher);

  const {
    modal: { showError }
  } = useContext(Context);

  const handleDownloadPaymentReceipt = () => {
    setFetchReceipt(true);
  };

  const handleDownloadVoucher = () => {
    if (!purchaseId) {
      console.error('purchaseId is undefined or null');
      showError({ title: 'Error', description: 'No se pudo obtener el ID de la cuenta de cobro' });
      return;
    }
    setIsDownloading(true);
    setFetchVoucher(true);
  };

  useEffect(() => {
    if (getReceiptSuccess) {
      utils.downloadFileByUrl(getReceipt).catch(error => {
        console.error('Error al descargar comprobante:', error);
        showError({ title: 'Error al descargar', description: 'No se pudo descargar el comprobante. Por favor, intenta nuevamente.' });
      });
      setFetchReceipt(false);
    } else if (getReceiptError) {
      showError({ title: 'Descargar comprobante', description: receiptErrorMessage });
      setFetchReceipt(false);
    }
  }, [getReceiptSuccess, getReceipt, getReceiptError, receiptErrorMessage, showError]);

  useEffect(() => {
    if (getVoucherSuccess) {
      try {
        // El body es un string JSON que necesita ser parseado
        const bodyData = JSON.parse(getVoucher.body);
        
        // Extraer la URL del archivo de la respuesta parseada
        const fileUrl = bodyData?.fileUrl;
        
        // Verificar que fileUrl sea una URL válida
        if (!fileUrl || typeof fileUrl !== 'string') {
          console.error('fileUrl is not a valid URL:', fileUrl);
          showError({ title: 'Error al descargar', description: 'No se pudo obtener la URL del comprobante de cobro.' });
          setIsDownloading(false);
          setFetchVoucher(false);
          return;
        }
         
        utils.downloadFileByUrl(fileUrl).then(() => {
          setIsDownloading(false);
        }).catch(error => {
          console.error('Error al descargar voucher:', error);
          showError({ title: 'Error al descargar', description: 'No se pudo descargar el comprobante de cobro. Por favor, intenta nuevamente.' });
          setIsDownloading(false);
        });
        setFetchVoucher(false);
      } catch (parseError) {
        console.error('Error parsing voucher response:', parseError);
        showError({ title: 'Error al descargar', description: 'Error al procesar la respuesta del comprobante de cobro.' });
        setIsDownloading(false);
        setFetchVoucher(false);
      }
    } else if (getVoucherError) {
      showError({ title: 'Descargar comprobante de cobro', description: voucherErrorMessage });
      setFetchVoucher(false);
      setIsDownloading(false);
    }
  }, [getVoucherSuccess, getVoucher, getVoucherError, voucherErrorMessage, showError]);

  return (
    <div className={containerClasses.join(' ')}>

      {isChargesMade ? (
        <>
          <div className={classes.title}>
            <div className={classes.head}>
              {!isSupplier && !payed && (
                <div className={classes['head-tag']}>
                <Button title={clientName} custom='tertiary' className={`${classes.business} text-ellipsis semibold-18`} onClick={goSupplier}>
                  {clientName}
                </Button>
                {paymentState === 'BEING_PAYED' && <Tags text='Proceso' type='orange'/>}
                </div>
              )}
            </div>
            <div className={classes['subtitle']}>{subtitle}</div>
            <div className={classes['last-date']}>
              <Calendar /> <span className={`${classes.text} medium-16`}>Se emitió el {moment(issueDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className={classes['last-date']}>
              <Calendar /> <span className={`${classes.text} medium-16`}>Vence el {moment(dueDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className={classes.down}>
              <span className='semibold-18'>Total a cobrar {utils.moneyFormat(payableAmountAfterRetentions)}</span>
            </div>
          </div>

          <div className={classes.values}>
            {payed && <span className='semibold-18'>{utils.moneyFormat(dueTotal)} pendientes</span>}
          </div>
          <div className={classes['recipt-details']}>
            <Button 
              Icon={ArrowDownLine} 
              onClick={handleDownloadVoucher} 
              className={`${classes.button} semibold-16`} 
              custom='quaternary'
              loading={isDownloading}
              disabled={isDownloading}
            >
              {isDownloading ? 'Descargando...' : 'Descargar comprobante'}
            </Button>
            <Button onClick={onClickDetail} className={`${classes.button} semibold-16`} custom='quaternary'>
              Ver detalles
            </Button>
          </div>
        </>
      ) : isPaymentReceived ? (
        <>
          <div className={classes.title}>
            <div className={classes.head}>
              {!isSupplier && !payed && (
                <Button title={clientName} custom='tertiary' className={`${classes.business} text-ellipsis semibold-18`} onClick={goSupplier}>
                  {clientName}
                </Button>
              )}
            </div>
            <div className={classes['subtitle']}>{subtitle}</div>
            <div className={classes['last-date']}>
              <Calendar /> <span className={`${classes.text} medium-16`}>Se emitió el {moment(issueDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className={classes.down}>
              <span className='semibold-18'>Total a cobrar {utils.moneyFormat(payableAmountAfterRetentions)}</span>
            </div>
          </div>

          <div className={classes.values}>
            {payed && <span className='semibold-18'>{utils.moneyFormat(dueTotal)} pendientes</span>}
          </div>
          <div className={classes['recipt-details']}>
            <Button Icon={ArrowDownLine} onClick={handleDownloadPaymentReceipt} className={`${classes.button} semibold-16`} custom='quaternary'>
              Descargar comprobante
            </Button>
            <Button onClick={onClickDetail} className={`${classes.button} semibold-16`} custom='quaternary'>
                Ver detalles
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className={classes.title}>
            <div className={classes.head}>
              {!isSupplier && !payed && (
                <Button title={clientName} custom='tertiary' className={`${classes.business} text-ellipsis semibold-18`} onClick={goSupplier}>
                  {clientName}
                </Button>
              )}
            </div>
            <div className={classes['subtitle']}>{subtitle}</div>
            <div className={classes['last-date']}>
              <Calendar /> <span className={`${classes.text} medium-16`}>Se emitió el {moment(issueDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className={classes['last-date']}>
              <Calendar /> <span className={`${classes.text} medium-16`}>Vence el {moment(dueDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className={classes.down}>
              <span className='semibold-18'>Total a cobrar {utils.moneyFormat(payableAmountAfterRetentions)}</span>
            </div>
          </div>

          <div className={classes.values}>
            {payed && <span className='semibold-18'>{utils.moneyFormat(dueTotal)} pendientes</span>}
          </div>
          {
            !payed && (
              <div className={classes['content-bottom']}>
                <div className={classes.totals}>
                  <span className={`${classes.color} medium-12`}>Recibo electrónico</span>
                </div>
                <Button onClick={onClickDetail} className={`${classes.button} semibold-16`} custom='quaternary'>
                  Ver detalles
                </Button>
              </div>
            )}
        </>
      )}
    </div>
  );
};

export default DetailsChargeCard;
